<template>
    <div class="tabela-slide-wrap">
        <table v-if="colunas.length && linhas.length" class="tabela-slide">
            <thead>
                <tr>
                    <th v-for="col in colunas" :key="col.campo">{{ col.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(linha, idx) in linhas" :key="chaveLinha(linha, idx)">
                    <td v-for="col in colunas" :key="col.campo" :title="valorCelula(linha, col.campo)">
                        {{ valorCelula(linha, col.campo) }}
                    </td>
                </tr>
            </tbody>
        </table>
        <p v-else class="slide-vazio">Nenhum registro neste slide.</p>
    </div>
</template>

<script>
import { obterValorColuna } from '@/utils/apresentacaoGestaoEntregas'

export default {
    name: 'TabelaSlideApresentacao',

    props: {
        colunas: {
            type: Array,
            default: () => [],
        },
        linhas: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        valorCelula(linha, campo) {
            return obterValorColuna(linha, campo)
        },

        chaveLinha(linha, idx) {
            return linha.entrega_id || linha.projeto_id || idx
        },
    },
}
</script>

<style scoped>
.tabela-slide-wrap {
    width: 100%;
    max-height: 100%;
    overflow: auto;
}

.tabela-slide {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.92rem;
}

.tabela-slide th {
    background: var(--cor-primaria, #00b6b3);
    color: #fff;
    text-align: left;
    padding: 0.55rem 0.65rem;
    font-weight: 600;
    white-space: nowrap;
}

.tabela-slide td {
    padding: 0.45rem 0.65rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    vertical-align: top;
    max-width: 14rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tabela-slide tbody tr:nth-child(even) {
    background: rgba(0, 182, 179, 0.06);
}

.slide-vazio {
    color: #666;
    font-style: italic;
    margin: 1rem 0;
}
</style>
